import { ThirdParty } from '@enmon/commons/lib/tools';
import { SelectProps } from 'antd';
import { useThirdParties } from 'hooks/useThirdParties';
import { VFC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Commodity } from '@enmon/commons/lib/shared';
import { Nullable } from '@enmon/commons';
import { Select } from './Select';
import { SelectMessages as messages } from './messages';

interface ThirdPartySelectProps extends SelectProps {
  commodity: Nullable<Commodity>;
  value?: ThirdParty['name'] | undefined;
  onChange?: (value: ThirdParty['name'] | null) => void;
}

export const ThirdPartySelect: VFC<ThirdPartySelectProps> = ({ commodity, ...restProps }) => {
  const { data: thirdParties, isLoading } = useThirdParties({ commodity });

  return (
    <Select
      allowClear
      showSearch
      className="w-100"
      filterOption={(input, option) =>
        (option?.label?.toString() ?? '').toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      loading={isLoading}
      options={thirdParties?.data?.map(thirdParty => ({ label: thirdParty.name, value: thirdParty.name })) ?? []}
      placeholder={<FormattedMessage {...messages.meterOwnerPlaceholder} />}
      {...restProps}
    />
  );
};
